var exports = {
  "Qr": "MarkdownTab.module__sectionsContainer___VTl0cF",
  "uW": "MarkdownTab.module__section___VTl0cF",
  "bV": "MarkdownTab.module__sectionHeader___VTl0cF",
  "AS": "MarkdownTab.module__item___VTl0cF",
  "Li": "MarkdownTab.module__itemHeader___VTl0cF",
  "IR": "MarkdownTab.module__itemLabel___VTl0cF",
};

module.exports = exports;
